import { TemplatePart } from './template-part.model';
/**
* The configuration for a template
*/
export class TemplateConfiguration {
    /**
     * The parts that make up a template
     */
    public templateParts: TemplatePart[];
    /**
     * The name of a template configuration
     */
    public name: string;
}
